import { type ChartSide, ChartViewEnum } from "~/feature/chart/types";

export const sidesByViewMode: Record<ChartViewEnum, ChartSide[]> = {
  [ChartViewEnum.YES]: [ChartViewEnum.YES],
  [ChartViewEnum.NO]: [ChartViewEnum.NO],
  [ChartViewEnum.BOTH]: [ChartViewEnum.YES, ChartViewEnum.NO],
  [ChartViewEnum.CONSENSUS]: [ChartViewEnum.YES],
};

export const isNoSide = (side: ChartSide): boolean => side === ChartViewEnum.NO;

export const getMarketLineKey = (marketId: string, side: ChartSide): string =>
  `${marketId}-${side}`;

export const CONSENSUS_LINE_KEY = "consensus";
